import Button from '@material-ui/core/Button';

export default function NextPrevious( {onNext, onPrevious, nextDisable}) {

    return (
        <>
            <Button onClick={onPrevious} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                Back
            </Button>
            <Button onClick={onNext} color="primary" disabled={nextDisable ? nextDisable : false} variant="contained" style={{ marginLeft: 10 }}>
                Next
            </Button>
        </>
    )
}